/**
 * Top-of-page maintenance banner. Shown on every screen (login + dashboard)
 * when system setting `maintenance_message` is non-empty. Admin-controlled.
 */
export function MaintenanceBanner({ message }) {
  if (!message || !message.trim()) return null;
  return (
    <div role="status" className="border-b border-warning/30 bg-warning-soft text-warning">
      <div className="mx-auto flex max-w-screen-2xl items-start gap-3 px-5 py-2.5 text-sm">
        <i className="fa-solid fa-triangle-exclamation mt-0.5 shrink-0" aria-hidden="true" />
        <p className="leading-snug">{message}</p>
      </div>
    </div>
  );
}
